/*

MIT License

Copyright (c) 2022 FrameMuse

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

*/

import { isBooleanString } from "./helpers"

/**
 * - Converts `0 | 1` to `false | true`.
 * - Converts `"0" | "1"` to `false | true`.
 * - Converts `"false" | "true"` to `false | true`.
 */
export function toBoolean(value: string | number) {
  if (typeof value === "string") {
    if (isBooleanString(value)) {
      return value.toLowerCase() === "true"
    }

    return Boolean(Number(value))
  }

  return Boolean(value)
}
